import {
  Component,
  inject,
  PLATFORM_ID,
  output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'd2d-reset-confirmation-modal',
  imports: [DialogModule, ButtonModule, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './reset-confirmation-modal.component.html',
})
export class ResetConfirmationModalComponent {
  private readonly platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  visible = signal(false);
  confirmed = output<void>();

  open(): void {
    this.visible.set(true);
  }

  cancel(): void {
    this.visible.set(false);
  }

  confirm(): void {
    this.visible.set(false);
    this.confirmed.emit();
  }
}
